export default {
    ru: {
        sender: 'Отправитель',
        recipient: 'Получатель',
        rate: 'Курс',
        amount_receive: 'К получению',
        status: 'Статус',
        paid: 'Оплата',
        payment_system: `Платежная система`,
        date: 'Дата',
        more: 'Подробнее',
        paid: 'Оплачено',
        unpaid: 'Не оплачено',
        timeout: 'Время вышло',
        timetopay: 'Время на оплату',
        zero_transfers: 'У вас еще нет переводов',
        error: 'Ошибка',
        copied: 'Copied',
        btn_create: 'Создать перевод'
    },
    en: {
        sender: 'Sender',
        recipient: 'Recipient',
        rate: 'Rate',
        amount_receive: 'To be received',
        status: 'Status',
        paid: 'Paid',
        payment_system: `Payment system`,
        date: 'Date',
        more: 'More info',
        paid: 'Paid',
        unpaid: 'Unpaid',
        timeout: 'Timeout',
        timetopay: 'Time to pay',
        zero_transfers: 'You have no transfers yet',
        error: 'Error',
        copied: 'Скопировано',
        btn_create: 'Create a transfer'
    }
}